import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useRouterContext } from "./Router";
export function Route404Component() {
    const ctx = useRouterContext();
    return _jsxs("div", { children: ["Route not found for path ", ctx.matchedRoutePath] });
}
export function createRoute404() {
    return {
        params: {},
        matchedSegments: [],
        state: null,
        value: {
            path: 'virtual:404',
            Component: () => _jsx(Route404Component, {})
        }
    };
}
//# sourceMappingURL=Route404.js.map